import React from 'react';
import { Widget } from 'shared/containers/portal_layout';

import { Fragments, Fragment } from 'shared/components/Fragments';

const Demographics = ({ demographics, calculated }) => (
  <Widget title="Patient Demographics" className="nopadding" span={12}>
    {demographics && demographics.subscriber ? (
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Description</th>
          </tr>
        </thead>
        <Fragments component="tbody">
          <Fragment>
            <tr className="gradeA">
              <td>Last Name: </td>
              <td>{demographics.subscriber.lastName}</td>
            </tr>
            <tr>
              <td>First Name: </td>
              <td>{demographics.subscriber.firstName}</td>
            </tr>
            <tr>
              <td>Member ID: </td>
              <td>{demographics.subscriber.memberId}</td>
            </tr>
            <tr>
              <td>Group ID: </td>
              <td>{calculated.groupId}</td>
            </tr>
            <tr>
              <td>Group Name: </td>
              <td>{calculated.groupName}</td>
            </tr>
            <tr>
              <td>DOB: </td>
              <td>{demographics.subscriber.dob}</td>
            </tr>
            <tr>
              <td>Gender: </td>
              <td>{demographics.subscriber.gender}</td>
            </tr>
          </Fragment>
          {demographics.subscriber.address && (
            <Fragment>
              <tr>
                <td>Address: </td>
                <td>
                  {demographics.subscriber.address.streetLine1},{' '}
                  {demographics.subscriber.address.streetLine2}
                </td>
              </tr>
              <tr>
                <td>City: </td>
                <td>{demographics.subscriber.address.city}</td>
              </tr>
              <tr>
                <td>State: </td>
                <td>{demographics.subscriber.address.state}</td>
              </tr>
              <tr>
                <td>ZIP: </td>
                <td>{demographics.subscriber.address.zip}</td>
              </tr>
            </Fragment>
          )}
        </Fragments>
      </table>
    ) : (
      <p>No demographic data available</p>
    )}
  </Widget>
);

export default Demographics;
